import React, { useState, useRef, useEffect } from 'react';
import { getReportCredit } from '../../services/cashFlow/cashFlow'
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { cedimi } from '../../constant/globalConstantsTypeClients';
import { getAllBranches } from '../../services/commercialLine/commercialLine'

import moment from 'moment';
import * as XLSX from 'xlsx';



export const useReportCredit = () => {

  // ? REPORT
  const [globalCancellFilter, setGlobalCancellFilter] = useState(null)
  const [chartDataCancell, setChartDataCancell] = useState({});
  const [chartOptionsCancell, setChartOptionsCancell] = useState({});
  const [countPatient, setCountPatient] = useState(0)
  const [cancellPatient, setCancellPatient] = useState([]);
  const chartCancellRef = useRef(null);
  const [createSweet] = useSweetAlert();
  const [loadingCancell, setLoadingCancell] = useState(false);
  let _cliente = localStorage.getItem('url_helen');
  const [branches, setBranches] = useState([]);

  const [mSelectBranch, setMSelectBranch] = useState(null);
  const [idBranch, setIdBranch] = useState(null);




  const [filters, setFilters] = useState({
    dateStart: moment().format("YYYY-MM") + "-01",
    dateEnd: moment().endOf('month').format("YYYY-MM-DD"),
  });

  useEffect(() => {
    GetReportCancell()
    getBranches();
  }, [])


  const getBranches = async () => {
    const branches = await getAllBranches();
    if (branches !== null && branches.length > 0) {
      let _allOption = {
        value: 0,
        label: "TODAS LAS SUCURSALES"
      };

      let _newBranches = [_allOption];

      branches.forEach((branch) => {
        _newBranches.push({
          value: branch.id_branch,
          label: branch.name
        });
      });

      setBranches(_newBranches);
    } else {
      setBranches([]);
    }
  }


  const GetReportCancell = async (alterDateStart = null, alterDateEnd = null) => {
    try {
      setLoadingCancell(true);


      let detailCancell = await getReportCredit(
        alterDateStart ?? filters.dateStart,
        alterDateEnd ?? filters.dateEnd,
        idBranch
      );

      if (detailCancell.code === 200) {
        let _dataCancell = detailCancell?.data ?? [];
        setCancellPatient(_dataCancell);
        setCountPatient(_dataCancell);
      }




    }
    catch (error) {
      createSweet("error", "error", "Opss..", "Error al obtener el reporte de credito");
    }
    finally {
      setLoadingCancell(false);
    }



  };


  function exportToExcelCancell() {
    let _Report = [];
    let _array = cancellPatient;

    _array.forEach((_find, key) => {
      let reportObject = {
        "Fecha de ingreso": _find?.fech ?? "---",
        "Nim": _find?.nim ?? "---",
        "Usuario de alta": _find?.userResponsable ?? "---",
        "Sucursal": _find?.branch ?? "---",
        "Monto": _find?.amount_deposit ?? "---",
        "Motivo de cancelación": _find?.reazon_cancellation ?? "---",
        "Usuario de recuperación": _find?.name_recupered ?? "---",
        "Fecha de recuperación": _find?.fech_recupered ?? "---"
      };



      _Report.push(reportObject);
    });
    const worksheet = XLSX.utils.json_to_sheet(_Report);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileName = 'Reporte de Creditos Particulares.xlsx';

    if (typeof window !== 'undefined' && window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
    } else {
      const url = window.URL.createObjectURL(dataBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }

  const handleReport = () => {
    GetReportCancell(filters.dateStart, filters.dateEnd);
  };


  const handleSelectValuesCash = (option, name) => {
    if (name === 'mSelectBranch') {

      setMSelectBranch(option);

      setIdBranch(option ? option.value : null);

      console.log("Sucursal seleccionada:", option);
      console.log("ID sucursal:", option?.value);
    }
  };

  const [viewCard, setViewCard] = useState(true)

  const handleViewCard = () => {
    setViewCard(!viewCard)
  }

  const handleCloseCard = () => {
    setViewCard(false)
  }




  const buildPendingByDay = (data) => {
    const grouped = {};

    data.forEach(item => {
      if (!item.fully_paid) {
        const day = item.fech.split(" ")[0];
        const key = day.substring(0, 5);

        grouped[key] = (grouped[key] || 0) + item.amount_deposit;
      }
    });

    return grouped;
  };

  const pendingByDay = buildPendingByDay(cancellPatient);

  const sortedDays = Object.keys(pendingByDay).sort((a, b) => {
    const [dayA, monthA] = a.split("/").map(Number);
    const [dayB, monthB] = b.split("/").map(Number);

    return new Date(2026, monthA - 1, dayA) - new Date(2026, monthB - 1, dayB);
  });


  const chartData = {
    labels: sortedDays,
    datasets: [
      {
        label: "Crédito pendiente ($)",
        data: Object.values(pendingByDay),
        fill: true,
        tension: 0.4,
        borderWidth: 2,
        pointRadius: 4
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "top"
      },
      tooltip: {
        callbacks: {
          label: (context) =>
            `$${context.parsed.y.toLocaleString()}`
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: value => `$${value.toLocaleString()}`
        }
      }
    }
  };

  const totalPendiente = cancellPatient
    .filter(x => !x.fully_paid)
    .reduce((sum, x) => sum + x.amount_deposit, 0);

  const totalPagado = cancellPatient
    .filter(x => x.fully_paid)
    .reduce((sum, x) => sum + x.amount_deposit, 0);

  const ordenesPendientes = cancellPatient.filter(x => !x.fully_paid).length;










  return {
    setFilters, filters, cancellPatient, globalCancellFilter, chartDataCancell,
    chartOptionsCancell, countPatient,
    setGlobalCancellFilter, handleReport,
    loadingCancell, exportToExcelCancell, chartCancellRef,
    branches, handleSelectValuesCash, mSelectBranch, idBranch,
    chartOptions, chartData, handleViewCard, handleCloseCard, viewCard,
    totalPendiente, totalPagado, ordenesPendientes






  }
}

